import axios from "axios";
import { firmOnboardingUrl, getLocationAndPincodeUrl, onboardCompanyRoleUrl } from "../urls";
import { getTokenHeader, getToken } from "../../../../screen/auth/action";

export const onboardCompanyRoleAction = async (payload) => {
  return new Promise(async (next) => {
    const params = new URLSearchParams(payload);
    let token = await getToken();
    await axios
      .get(onboardCompanyRoleUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};

export const getLocationAndPincodeAction = async (id, params = {}) => {
  return new Promise(async (next) => {
    await axios
      .get(`${getLocationAndPincodeUrl()}?district_id=${id}`, { params })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const firmOnboardingAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken(); 
    await axios
      .post(
        `${firmOnboardingUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      }) 
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};